import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const ArrowForward = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.886 16.83a.941.941 0 1 0 1.33 1.332l5.508-5.496a.941.941 0 0 0 0-1.332l-5.508-5.496a.941.941 0 1 0-1.33 1.333l3.896 3.888H4.972a.941.941 0 1 0 0 1.882h11.81l-3.896 3.888Z"
      fill={color}
    />
  </Svg>
)

export default ArrowForward
